<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="客户管理">
      <template v-if="hasPermission('配置-客户管理-新增')">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增客户</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
    >
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <template v-if="hasPermission('配置-客户管理-编辑')">
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          </template>

          <template v-if="hasPermission('配置-客户管理-编辑')">
            <div class="button button_revoke" @click="switchingStates(row.row)">
              <i
                :class="
                  row.row.status == 1
                    ? 'iconfont icon-lock'
                    : 'iconfont icon-jihuo'
                "
              ></i
              >{{ row.row.status == 0 ? "锁定" : "激活" }}
            </div>
          </template>

          <template v-if="hasPermission('配置-客户管理-删除')">
            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>

          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 激活
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  customerGetList,
  customerDel,
  customerActive,
  customerLock,
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "customerManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      compId: null,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "编号",
            type: "inputNumber",
            key: "id",
            width: 100,
          },
          {
            label: "名称/电话/昵称",
            type: "input",
            key: "keywords",
          },
          {
            label: "分类",
            type: "select",
            key: "type_id",
            options: [
              {
                value: 1,
                label: "同行",
              },
              {
                value: 2,
                label: "分销",
              },
              {
                value: 3,
                label: "团购",
              },
              {
                value: 4,
                label: "外卖",
              },
              {
                value: 5,
                label: "零售(POS)",
              },
            ],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "激活",
                value: 0,
              },
              {
                label: "锁定",
                value: 1,
              },
            ],
          },
        ],
        data: [],
        column: [
          // {
          //   label: "编号",
          //   prop: "id",
          //   width: 50,
          // },
          {
            label: "名称（昵称）",
            prop: "name",
            width: 200,
          },
          // {
          //   label: "昵称",
          //   prop: "nick_name",
          //   width: 200,
          // },
          {
            label: "关联店员",
            prop: "user_name",
          },
          {
            label: "分类",
            prop: "type_id",
            filter: "customerClassification",
          },
          {
            label: "交易金额",
            prop: "total_pay_monye",
            isMoney: true,
            sortable: true,
          },
          {
            label: "交易次数",
            prop: "pay_count",
            sortable: true,
          },
          {
            label: "余额",
            isMoney: true,
            prop: "money",
            sortable: true,
          },
          {
            label: "上次交易时间",
            prop: "last_pay_time",
            width: 120,
            sortable: true,
          },
          {
            label: "状态",
            prop: "status",
            filter: "storeStatus",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    // 初始化列表内容
    this.getlist();
  },
  computed: {
    ...mapGetters(["hasPermission"]),
  },
  methods: {
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        customerLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        customerActive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        customerDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      this.basicListconfig.searchParameters.is_showAll = 1;
      customerGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/customerManagement/index.vue